import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { GraduationCap, Users, Clock } from "lucide-react";

export default function Learning() {
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get("/learning/courses").then((r) => setCourses(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-1">Learning & Growth</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Curated learning paths</h1>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {courses.map((c) => (
          <Card key={c.id} className="border-border shadow-none p-5 hover:border-[#0047AB] transition-colors">
            <div className="flex items-start justify-between">
              <div className="h-10 w-10 rounded-md bg-indigo-50 text-indigo-700 grid place-items-center"><GraduationCap className="h-5 w-5" /></div>
              <Badge variant="outline" className="text-[10px] font-mono uppercase tracking-wider">{c.category}</Badge>
            </div>
            <h3 className="font-display font-bold text-lg tracking-tight mt-4 leading-tight">{c.title}</h3>
            <div className="mt-3 flex items-center gap-4 text-xs text-muted-foreground">
              <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> {c.duration}</span>
              <span className="flex items-center gap-1"><Users className="h-3 w-3" /> {c.learners}</span>
              <span>· {c.level}</span>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
